module.exports = __webpack_public_path__ + "static/media/file-icon.f5aa44ed.svg";